// form
import { useForm } from 'react-hook-form';
import { CreatePlansService } from "../../../services/admin/plans/createPlans.tsx";
import { UpdatePlans } from "../../../services/admin/plans/updatePlans.tsx";
// param
import { useNavigate, useParams } from "react-router-dom";
import { ShowPlan } from "../../../services/admin/plans/showPlan.tsx";
// custom hooks
import useSendData from "../../../hook/sendData.tsx";
import useUpdateData from "../../../hook/updateData.tsx";
import useGetData from "../../../hook/getData.tsx";
// hook
import { useEffect } from 'react';

export const CreateOrUpdatePlans = () => {
    const { register, handleSubmit, reset }: any = useForm<any>();
    const { id } = useParams();
    const navigator = useNavigate();
    const { data, refetch } = useGetData(['plans', id], ShowPlan)
    let sendData: any, updateData: any;
    const { send, pending } = useSendData(sendData, CreatePlansService, refetch);
    const { update, pendingUpdate } = useUpdateData(updateData, UpdatePlans, refetch, navigator, '/dashboard/admin/plans');
    const onSubmit = (data: any) => {
        if (id) {
            let newData = data;
            newData.id = id;
            newData._method = 'PUT'
            update(newData)
        }
        else {
            send(data)
        }
    }
    useEffect(() => {
        if (data) {
            reset({
                title: data.title,
                options: data.options,
                price: data.price,
            });
        }
    }, [data, reset]);
    return { register, handleSubmit, pending, pendingUpdate, onSubmit, id }
}